<template>
  <div style="width:100%;height:100%;position:absolute;top:0;bottom:0;left:0;right:0">
    <div class="desc-bg"></div>
    <!--<div class="bg-opacity"></div>-->
    <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
      <div class="login-div">

        <div class="box-login">
          <div v-if="checkServiceVersion(2)" class="flex justify-center login-header-platformfy">
            <!--<div style="line-height:48px;color:white;font-weight:bold">관리자 로그인</div>-->
            <img src="~assets/image/login_logo_platformfy.png" style="width:135px;margin:auto;">
          </div>
          <div v-else class="flex justify-center login-header">
            <!--<div style="line-height:48px;color:white;font-weight:bold">관리자 로그인</div>-->
            <img src="~assets/image/login_logo.png" style="width:135px;margin:auto;">
          </div>
          <div class="login-content-div">
            <div style="padding: 40px;text-align:center">
              <!--<div class="lp-login-logo" style="margin:0 auto"></div>
              <div class="flex justify-center" style="font-size:1.2rem;margin-top:4px">LAUNCH PACK</div>-->
              <div style="font-weight:bold;font-size:1.2rem">관리자 로그인</div>
            </div>
            <div style="padding:0 42px 68px 42px;">
              <div>
                <input :style="errorStyle"
                       type="text" placeholder="아이디" v-model="item.username"
                       name="아이디"/>
              </div>
              <!--<span v-show="errors.has('아이디')" class="help is-danger">{{ errors.first('아이디') }}</span>-->
              <div style="margin-top:8px">
                <input :style="errorStyle" @focus="isError=false" id="input-password" type="password" placeholder="비밀번호" @keyup.enter="login" v-model="item.password"
                       name="비밀번호" v-validate="'required'"/>
              </div>
              <span v-show="errors.has('비밀번호')" class="help is-danger">{{ errors.first('비밀번호') }}</span>
              <span v-if="item.wrong_msg && item.password" class="help is-danger">{{ item.wrong_msg }}</span>
              <button id="btn-login" class="btn" :style="loginButtonStyle" @click="login">로그인</button>
            </div>
          </div>
        </div>

        <div class="flex" v-if="false">
          <div class="flex" style="margin-left: auto;">
            <div class="flex">
              <div class="btn">아이디 찾기</div>
            </div>
            <div class="flex" style="margin-left: 10px;">
              <div class="btn">비밀번호 찾기</div>
            </div>
          </div>
        </div>

        <div style="margin-top:16px" v-if="email">
          <div class="size-12" style="margin-top:4px">
            아이디와 비밀번호는 서비스 첫 개설 시 가입했던 {{ email }} 메일로 안내 되었습니다.<span class="primary unselect" style="margin-left:4px" @click="sendEmail">계정 안내 메일 재발송</span>
          </div>
          <div class="login-desc">{{ loginInfo }}</div>
          <template v-if="checkServiceVersion(2)">
            <div class="login-desc">플랫폼파이를 방문하시려면 <a href="https://platformfy.com" target="_blank">플랫폼파이 바로가기</a>를 클릭해주세요.</div>
          </template>
          <template v-else>
            <div class="login-desc">런치팩을 방문하시려면 <a href="https://launchpack.co.kr" target="_blank">런치팩 바로가기</a>를 클릭해주세요.</div>
          </template>
        </div>

        <!--<div class="copyright">Copyright @ Launchpack. All rights reserved.</div>-->
      </div>
    </div>

    <modal name="sendEmailModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper" v-if="email && service">
        <div class="size-21" style="color:#363636">계정 안내 메일 재발송 완료</div>
        <div style="margin-top:24px;margin-bottom:24px">{{ email }} 메일로 {{ service.title }} 플랫폼 관리자 계정 안내 메일이 재발송 되었습니다.</div>
        <div class="flex-between">
          <button class="button" style="border:1px solid #dbdbdb" @click="$modal.hide('sendEmailModal')">확인</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  export default {
    name: 'AdminLogin',
    created() {
      this.setIsDemoOffice();
      this.setIsFirstLogin();
      if(this.$route.query.pf) {
        const [username, password] = this.$route.query.pf.split('%102^');
        this.item.username = username;
        this.item.password = password;
      }
    },
    data() {
      return {
        item: {
          username: '',
          password: '',
          wrong_msg: ''
        },
        isError: false,
        enable_activate: false,
        loginInfo: '',
        email: '',
        service: undefined,
        enableResendBtn: true
      }
    },
    watch: {
      'item.username'(n){
        //console.log(n)
      }
    },
    computed: {
      errorStyle(){
        if(this.isError){
          return 'border: 1px solid red';
        }
      },
      loginButtonStyle(){
        if(this.item.username && this.item.password){
          return 'color: white; background-color: #ff6e49';
        }
      }
    },
    methods: {
      sendEmail() {
        if(!this.enableResendBtn) return;
        this.enableResendBtn = false;
        let url = `public/account/resend`
        this.$axios.post(url).then(res=>{
          this.enableResendBtn = true;
          this.$modal.show('sendEmailModal')
        })
      },
      setIsFirstLogin() {
        this.loginInfo = '아이디 비밀번호를 모르는 경우 서비스 개설 안내 메일을 확인하세요.\n비밀번호 변경은 서비스 설정관리>관리자 계정설정에서 가능합니다.';
        /*this.$axios.get('public/service/setting').then(res=>{
          if(res.data.first_login) {
            this.loginInfo = '아이디와 비밀번호를 입력하시면 관리자로 로그인 하실 수 있습니다.';
          } else {
            this.loginInfo = '아이디, 비밀번호를 모르시는 경우, 서비스 개설 안내 메일을 확인하세요.';
          }
        });*/
      },
      async setIsDemoOffice() {
        if(location.href.indexOf('demooffice')>-1) {
          this.item.username = 'demotest';
          this.item.password = 'demo';
          setTimeout(()=>{
            this.login();
          },300);
        } else {
          let res = await this.$axios.get(this.backendUrl+'/public/service/info')
          if(res) {
            this.service = res.data;
            this.$axios.get(this.masterBackendUrl+`public/launchpack/service/${this.service.service_key}/admin_id`).then(res=>{
              this.email = res.data;
            })
          }
        }
      },
      login() {
        this.$validator.validateAll().then((res)=>{
          if (res === false) return;

          let params = {
            username: this.item.username,
            password: this.item.password
          };
          this.$axios.post('/auth/admin/login', params)
            .then(res => {
              if (res.status === 200) {
                this.$store.commit('setAdmin', res.data.user);
                this.$store.commit('setServiceName', res.data.user.service);
                this.setAuthHeader();
                //console.log('auth',this.$axios.defaults.headers.common['Authorization'])

                // 현재 파트너인지 관리자인지 구분
                if(this.$store.getters.admin.token!=='') {
                  this.$store.commit('setMode', 'admin');
                }
                let prevPath = this.$store.getters.previousPath;
                if(prevPath!=='') {
                  this.$router.replace(prevPath);
                }
                else if(!this.isLaunchpack) {
                  this.$router.replace('/office/admin/dashboard')
                }
                else {
                  this.$router.replace('/office/admin/user')
                }
              }
            })
            .catch(error => {
              if(!error.response && error.message) {
                this.item.wrong_msg = error.message;
              }
              else if (error.response.status > 400) {
                if (error.response.data.detail){
                  this.item.wrong_msg = error.response.data.detail;
                  this.isError=true;
                }
                else{
                  this.item.wrong_msg = error.response.data.message;
                  this.isError=true;
                }
              }
            });
        });

        if(!this.isLaunchpack) {
          // 서비스 키 가져와서 접속시간 체크
          if (this.$store.state.brand.service) {
            this.$axios.post(this.masterBackendUrl+'public/service/connect/time', {
              service_key: this.$store.state.brand.service
            }).then(res => {
              if (res.status === 200) {
              }
            })
          }
        }
      }
    }
  }
</script>

<style type="styl" lang="stylus" scoped>
  .lp-login-logo
    width 30px
    height 30px
    background-image url('~assets/image/platformfy_logo.png')

  .desc-bg
    width 100%
    height 100%
    background-color #f5f5f5
    position fixed

  .bg-opacity
    background-color rgba(247, 247, 247,0.25)
    width 100%
    height 100%
    position fixed

  .copyright
    margin-top 60px
    color #A8A9AC
    text-align center
    font-size 12px
    font-weight 300

  .btn
    padding 10px 15px
    text-align center
    background-color #e5e5e5
    color #989898
    font-weight bold
    border-radius 3px
    font-size 14px
    margin-top 20px
    min-width: 80px
    cursor pointer

  input[type="text"], input[type="password"], textarea
    padding 10px
    font-size 14px
    border-radius 3px
    border 1px solid #e6e6e6
    width 100%
    max-width 500px
    background-color #fff

  input:focus
    border 1px solid #ff5722
    outline 0

  .help.is-danger
    color #ff3860
    font-size 13px
    margin-top 5px
    display block
    text-align left

  .login-div
    width 388px
    position relative

  .login-header
    height 48px
    background-color #ff6e49
    border-top-left-radius 3px
    border-top-right-radius 3px

  .login-header-platformfy
    height 48px
    background-color #ff6600
    border-top-left-radius 3px
    border-top-right-radius 3px

  .login-content-div
    background-color white
    border-bottom-left-radius 3px
    border-bottom-right-radius 3px

  .login-desc
    font-size 12px
    margin-top 4px
    white-space pre-line

  .activate
    color: white;
    background-color: #ff6e49
  a
    text-decoration underline
    color #000
  a:hover
    color #ff5722

  .box-login
    box-shadow 0 1px 6px 1px rgba(0,0,0,0.12)
  button
    width 100%
    border 0
</style>
